import slugifyLib from 'slugify';

export const slugify = (text = '') => {
  const slug = slugifyLib(text, {
    lower: true,
    // eslint-disable-next-line no-useless-escape
    remove: /[$*_+~.()\^\?;\[\]\\'"!:@%#,=]/g
  });

  return slug;
};
